/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const ChannelsType = {
    ALL: 'allChannels',
    SUBSCRIBED: 'subscribedChannels',
} as const;

export type ChannelsType = typeof ChannelsType[keyof typeof ChannelsType];
